import blog1 from '../Asets/images/01.jpg';
import blog2 from '../Asets/images/02.jpg';
import blog3 from '../Asets/images/03.jpg';




const Data = [
    {
      img : blog1,
      title : 'Rainbow Vegetable Sandwich',
      time : '15 - 20 Minutes',
      price : '$19.50'
    },
    {
      img : blog2 ,
      title : 'Vegetarian Burger',
      time : '30 - 45 Minutes',
      price : '$20.50'
    },
    {
      img : blog3,
      title : 'Raspberry Stuffed French Toast',
      time : '10 - 15 Minutes',
      price : '$10.50'
    }
  ]

export default Data;